import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { Container, InputGroup, Input, Button, Table } from 'reactstrap';
import axios from 'axios';
import VideosDetail from './VideosMyDetail';
import stylesCoup from '../Shared/Css/VideosMy/VideosMyListSerche.module.css';

// const defaultEmpVideoSrc = '/empImg/video_placeholder.png'
const defaultEmpVideoExcelSrc = '/empImg/excel_placeholder.png';
const defaultEmpVideoPdflSrc = '/empImg/pdf_placeholder.png';
const defaultEmpVideoTxtlSrc = '/empImg/text_placeholder.png';

function VideosListSerche() {
  const [videosList, setVideosList] = useState([]);
  const [randring, setRandring] = useState(false);
  const [videoValue, setVideoValue] = useState(null);
  const [videosDetailTrue, setVideosDetailTrue] = useState(false);
  const [empNameChange, setEmpNameChange] = useState('');

  //히스토리사용
  const history = useHistory();

  useEffect(() => {
    if (randring === false) {
      setRandring(true);
      refreshEmpList();
    }
    //경고문 해제
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const headers = useCallback(() => {
    return {
      'Content-type': `text/plain`,
      // headers: { "Content-Type": `multipart/form-data` }
    };
  }, []);

  const empAPI = useCallback(() => {
    const url = '/api/VideosMy/';
    const urlFileDown = '/api/VideosMyFileDown/';

    return {
      fetchAll: () => axios.get(url, { params: { empName: empNameChange } }),
      download: (id) => axios.get(urlFileDown + id, { headers }),
    };
  }, [empNameChange, headers]);

  const onDownload = useCallback(
    (e, id) => {
      e.preventDefault();
      if (window.confirm('다운로드를 하겠습니까?'))
        empAPI()
          .download(id)
          .then((res) => {
            const url = res.config.url;
            window.location.href = url; //다운로드 Url
          })
          .catch((err) => console.log(err));
    },
    [empAPI]
  );

  const refreshEmpList = useCallback(async () => {
    await empAPI()
      .fetchAll()
      .then((res) => {
        setVideosList(res.data);
      })
      .catch((err) => console.log(err));
  }, [empAPI]);

  const videoHandle = (e) => {
    setVideoValue(e.target.src);
    setVideosDetailTrue(true);
  };

  const handleInputEmpNameChange = (e) => {
    e.preventDefault();
    setEmpNameChange(e.target.value);
  };

  const handleInputEmpNameEnter = (e) => {
    e.preventDefault();
    if (e.key === 'Enter') {
      refreshEmpList(); // Enter 입력이 되면 클릭 이벤트 실행
    }
  };
  const handleInputEmpNameChangeQuary = (e) => {
    e.preventDefault();
    refreshEmpList(); // Enter 입력이 되면 클릭 이벤트 실행
  };

  const empImageCard = useCallback(
    (data) => (
      <div className={`card ${stylesCoup.cardd}`} >
        {data.empImageType === 'image/png' ? (
          <img
            src={data.empImageSrc}
            className={`card-img-top rounded-circle`}
            alt=""
          />
        ) : data.empImageType === 'image/bmp' ? (
          <img src={data.empImageSrc} className="card-img-top rounded" alt="" />
        ) : data.empImageType === 'image/jpeg' ? (
          <img src={data.empImageSrc} className="card-img-top rounded" alt="" />
        ) : data.empImageType === 'image/gif' ? (
          <img src={data.empImageSrc} className="card-img-top rounded" alt="" />
        ) : data.empImageType === 'video/mp4' ? (
          <video
            src={data.empImageSrc}
            controlsList="nodownload"
            className="card-img-top rounded"
            onClick={videoHandle}
          ></video>
        ) : data.empImageType ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ? (
          <img
            src={defaultEmpVideoExcelSrc}
            className="card-img-top rounded"
            alt=""
          ></img>
        ) : data.empImageType === 'application/pdf' ? (
          <img
            src={defaultEmpVideoPdflSrc}
            className="card-img-top rounded"
            alt=""
          ></img>
        ) : data.empImageType === 'text/plain' ? (
          <img
            src={defaultEmpVideoTxtlSrc}
            className="card-img-top rounded"
            alt=""
          ></img>
        ) : (
          <img src={data.empImageSrc} className="card-img-top rounded" alt="" />
        )}
        <div className={`card-body pt-1 ${stylesCoup.cardBody}`}>
          <Table bordered size="sm"
            className={`mt-0 mb-0 ${stylesCoup.empTableCard}`}
          >
            <thead>
              <tr>
                <th>영상명</th>
                <th>시리얼No</th>
                <th>평점</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{data.empName}</td>
                <td>{data.empSabun}</td>
                <td>{data.empGicwi}</td>
              </tr>
            </tbody>
            <thead>
              <tr>
                <th>등록일</th>
                <th colSpan={2}>교육영상기타</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{data.empIpSaIl}</td>
                <td colSpan={2}>{data.empDesc}</td>
              </tr>
            </tbody>
          </Table>
          <button
            className={`btn btn-white ${stylesCoup.deleteButton}`}
            onClick={(e) => onDownload(e, parseInt(data.empId))}
          >
            <i
              className={`fa-regular fa-floppy-disk ${stylesCoup.deletIcon}`}
            // style={{ marginTop: '0px', fontSize: '16px', color: 'blue' }}
            ></i>
          </button>
        </div>
      </div>
    ),
    [onDownload]
  );

  return (
    <Container fluid="fluid" className={stylesCoup.empContainerSerche}>
      <div className="row">
        <div className={`col-md-12 ${stylesCoup.empDamun}`}>
          <Button color="warning" className={stylesCoup.btn}
            onClick={() => { history.goBack(); }}
          // onClick={() => { history.push('/'); }}
          // onClick={() => {
          //   window.location.href = '/home/index';
          // }}
          >
            나가기
          </Button>
          <div
            className={`container-fluid p-5 mt-1 bg-primary text-white ${stylesCoup.empHidden}`}
            style={{ textAlign: 'center' }}
          >
            <h1>영상현황</h1>
            <p className="lead">검색 [빈값 Enter는 전체조회].</p>
          </div>
        </div>
        <div className="col-md-12">
          <div className={`row ${stylesCoup.empList}`}>
            <div className={`col-10 ${stylesCoup.empLi00}`} >영상리스트</div>
            <div className={`col-2 ${stylesCoup.empLi01}`}>
              <InputGroup size="sm">
                <Input
                  className={stylesCoup.empPlSerche}
                  placeholder="검색"
                  name="empNameChange"
                  value={empNameChange}
                  onChange={handleInputEmpNameChange}
                  onKeyUp={handleInputEmpNameEnter}
                  onClick={() => {
                    setEmpNameChange('');
                  }}
                />
                <Button
                  size="sm"
                  color="success"
                  style={{ marginRight: '4px' }}
                  onClick={handleInputEmpNameChangeQuary}
                >
                  <i className="fa-solid fa-magnifying-glass" />
                </Button>
              </InputGroup>
            </div>
          </div>
          {Math.ceil(videosList.length) !== 0 ? (
            <table>
              <tbody className={stylesCoup.empTbody}>
                {[...Array(Math.ceil(videosList.length / 3))].map((e, i) => {
                  return (
                    <tr key={i}>
                      <td>{empImageCard(videosList[3 * i])}</td>
                      <td>
                        {videosList[3 * i + 1]
                          ? empImageCard(videosList[3 * i + 1])
                          : null}
                      </td>
                      <td>
                        {videosList[3 * i + 2]
                          ? empImageCard(videosList[3 * i + 2])
                          : null}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div className={stylesCoup.empContainermessage01}>
              <div className={stylesCoup.empContainermessage02}>
                <p>검색된 자료가 없습니다.</p>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* 비디오재생모달 */}
      {videosDetailTrue === true ? (
        <VideosDetail
          videosDetailTrue={videosDetailTrue}
          setVideosDetailTrue={setVideosDetailTrue}
          videoValue={videoValue}
        />
      ) : null}
    </Container>
  );
}

export default VideosListSerche;
